import { create } from "zustand";

interface FirmwareInfo {
  id: number;
  name: string;
}

interface FirmwareStoreState {
  firmwares: Record<number, FirmwareInfo>;
  setFirmware: (firmware: FirmwareInfo) => void;
  getFirmware: (id: number) => FirmwareInfo | undefined;
  clearFirmwares: () => void;
}

export const useFirmwareStore = create<FirmwareStoreState>((set, get) => ({
  firmwares: {},

  setFirmware: (firmware: FirmwareInfo) => {
    set((state) => ({
      firmwares: {
        ...state.firmwares,
        [firmware.id]: firmware,
      },
    }));
  },

  getFirmware: (id: number) => {
    return get().firmwares[id];
  },

  clearFirmwares: () => {
    set({ firmwares: {} });
  },
}));
